import { PriceListResponse } from "webshop-api";
import { PriceLevelState, PriceLevelStateMapper } from "@/domain/ticket-selection";

export class PriceLevelStateCollectionFactory {

    public static buildFromPriceList(object: PriceListResponse, applicationTicketMaximum: number): PriceLevelState[] {
        if (!object || !object.priceLevels) {
            return [];
        }
        const promotionList = object.promotions || [];

        return object.priceLevels.map((entity, index, array) =>
            PriceLevelStateMapper.fromPriceLevel(entity, index, array, applicationTicketMaximum, promotionList)
        );
    }

}
